import { gql } from "@apollo/client";

import complianceProgramCalibrationGroupFragment from "./compliance-program-calibration-group-fragment";

export default gql`
  ${complianceProgramCalibrationGroupFragment}
  mutation saveCalibrationGroup(
    $complianceProgramId: Int!
    $name: String!
    $userIds: [Int!]!
    $managerIds: [Int!]!
    $approverIds: [Int!]!
    $id: Int
  ) {
    createOrUpdateCalibrationGroup(
      complianceProgramId: $complianceProgramId
      name: $name
      userIds: $userIds
      managerIds: $managerIds
      approverIds: $approverIds
      id: $id
    ) {
      calibrationGroup {
        ...ComplianceProgramCalibrationGroup
      }
    }
  }
`;
